import React, { useState } from "react";
import { MPSharedTable, MPSharedDeleteModal, MPSharedHeader } from "../Shared";
import { useSearchQuery, usePagination, useDelete, useQuery } from "../../../hooks";
import { useGetEventConfigurationsQuery, useDeleteEventConfigurationMutation, useGetEventTypesQuery } from "../services";
import { EventConfigurationsForm } from "./form";
import { Link } from "react-router-dom";
import {getLocalizedString} from "../../../shared/translation";

export const EventConfigurationsContainer = () => {
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToEdit, setIdToEdit] = useState(null);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const { page, setPage, perPage, pagination } = usePagination();

  const { setSimpleSearch, simpleSearch } = useSearchQuery({
    page,
    setPage,
  });

  // Fetch event types to get the "trip" event type ID dynamically
  const { data: eventTypesData } = useGetEventTypesQuery({ per_page: 100 });
  const tripEventTypeId = eventTypesData?.data?.find((et) => et.name === "trip")?.id;

  //Stores the query parameters
  const queryParams = {
    page: page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
  };

  const query = useQuery();
  let filterHeader = "";

  //Used for the filter message for the count clicks
  const filters = [
    {
      label: " " + getLocalizedString("geofence_lowercase", " geofence")  + ": ",
      key: "geofence_id",
    },
  ];

  filters.map((filter) => {
    if (query.get(filter.key)) {
      queryParams[filter.key] = query.get(filter.key);
      filterHeader = `${filter.label} ${query.get("name")}`;
    }
  });

  const {
    data = {
      total_count: 0,
      data: [],
    },
    error,
    isFetching,
    isSuccess,
  } = useGetEventConfigurationsQuery({
    ...queryParams,
    q: JSON.stringify({ ...(tripEventTypeId ? { event_type_id_not_in: [tripEventTypeId] } : {}), name_cont: simpleSearch }),
  });

  const {
    deleteItem: deleteEventConfigurationPlan,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteEventConfigurationMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const headers = [
    {
      label: getLocalizedString("name", "Name"),
      key: "name",
      className: "name",
    },
    {
      label: getLocalizedString("event_plans", "Event Plans"),
      nestedValue: true,
      className: "more event-configuration-plans text-center justify-center",

      getNestedValue: ({ event_handling_plans_count, id, name }) => {
        return (
          <>
            {event_handling_plans_count > 0 ? (
              <Link
                to={`/management_portal/configurations/event_plans?event_configuration_id=${id}&name=${name}`}
                style={{ textDecoration: "none" }}
              >
                {event_handling_plans_count}
              </Link>
            ) : (
              <span>0</span>
            )}
          </>
        );
      },
    },
    {
      label: getLocalizedString("type", "Type"),
      type: "component",
      className: "type more",
      component: ({ data }) => {
        const name = data?.event_type?.split("_").map((word) => {
          // Display Ignition Status Change instead of Ignition Onchange
          return word === "onchange"
            ? "Status Change"
            : word.charAt(0).toUpperCase() + word.substring(1, word.length) + " ";
        });

        return <span>{name}</span>;
      },
    },
    {
      label: getLocalizedString("added_on", "Added On"),
      key: "created_at",
      className: "date",
    },
    // { label: "Added By", key: "created_by" },
  ];

  const onEdit = (data) => {
    setShowForm(true);
    setIdToEdit(data.id);
  };

  const onDelete = (data) => {
    setShowDeleteWarning(true);
    setIdToDelete(data.id);
  };

  const onCreate = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data.findIndex((item) => item.id === id);

    if (index >= 0) {
      name = data.data[index].name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <MPSharedHeader
          groupName="configurations"
          resourceName="Event Configurations"
          createNewHandler={onCreate}
          heading={getLocalizedString("configurations", "Configurations")}
          handleSearchKey={setSimpleSearch}
          simpleSearchPlaceholder={getLocalizedString("search_by_name", "Search by Name")}
          filterText={
            filterHeader &&
            `${getLocalizedString("filtered_by", "Filtered by")} ${filterHeader}`
          }
        />

        <MPSharedTable
          resourceName="Event Configurations"
          data={data?.data || []}
          error={error}
          isLoading={isFetching}
          isSuccess={isSuccess}
          headers={headers}
          onEdit={onEdit}
          onDelete={onDelete}
          pagination={{ ...pagination, count: data.total_count }}
          skipClientId
          className="event-configuration"
          auditResource="EventConfiguration"
          auditKey="name"
        />
      </article>

      {showForm && (
        <EventConfigurationsForm idToEdit={idToEdit} onClose={() => setShowForm(false)} />
      )}

      <MPSharedDeleteModal
        show={showDeleteWarning}
        entityName={getLocalizedString("event_configuration", "Event Configuration")}
        error={deleteErrorMsg}
        itemName={getDeleteItemName(idToDelete)}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        onDelete={() => deleteEventConfigurationPlan({ id: idToDelete })}
      />
    </>
  );
};
